import React from "react";
import AppLayout from "../components/AppLayout";
import QuoteCalculator from "../components/QuoteCalculator";
import { useQuote } from "../context/QuoteContext";

const QuotePage = () => {
    const { items, setItems } = useQuote();
    return (
        <AppLayout pageTitle="Preventivo" showBack backTo="/">
            <QuoteCalculator items={items} setItems={setItems} />
        </AppLayout>
    );
};

export default QuotePage;
